import CheckAuthorization from './CheckAuthorization';

export default CheckAuthorization;
